export enum Page {
	ACTS,
	INFO,
	SIGN,
	CANCEL,
	FILTER,
}

export const HEADER_NAMES = {
	[Page.ACTS]: 'Акты',
	[Page.INFO]: 'Сведения об акте',
	[Page.SIGN]: 'Подписание акта',
	[Page.CANCEL]: 'Отклонение акта',
	[Page.FILTER]: 'Фильтр',
}

const SMS_ERROR_CODE = {
	INVALID: 'invalid',
	UNUSED_SMS: 'too_many_unused_sms',
}

export const ERROR_CODE = [SMS_ERROR_CODE.INVALID, SMS_ERROR_CODE.UNUSED_SMS]

export const ERROR_CODE_SMS = 'sms_timeout'

export const OPTIONS_BOOLEAN_SELECT = [
	{ id: 'true', name: 'Да' },
	{ id: 'false', name: 'Нет' },
]
